const heart_questions  = [
   {
      "question":"How is ##name## being evaluated today?",
      "sub":"",
      "type":"radio",
      "telehealth":"form1[0].#subform[0].SectionI-DXSF[0].UnderNameNotes[0].Public2507Questions[0].HowExamCOnducted[0]",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "questions":[
         {
            "label":"How was the examination conducted?",
            "title":"",
            "subMain":"",
            "sub":"",
            "radioGroup":"form1[0].#subform[0].SectionI-DXSF[0].UnderNameNotes[0].Public2507Questions[0].RadioButtonList[2]",
            "options":[
               {
                  "main":"In-Person Exam",
                  "dbqName":"1",
                  "sub":""
               },
               {
                  "main":"Video Telehealth",
                  "dbqName":"2",
                  "sub":""
               }
            ],
            "answer":"In-Person Exam"
         }
      ]
   },
   {
      "question":"Is ##name## regularly seen as a patient in your clinic?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"form1[0].#subform[0].SectionI-DXSF[0].UnderNameNotes[0].Public2507Questions[0].RadioButtonList[1]",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Did you review any of the patients records for this condition?",
      "sub":"Please identify the evidence reviewed and the date range",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "EVIDENCE REVIEW",
         number: "0"
      },
      "presidence":"Yes",
      "maxLength":2730,
      "radioGroup":"form1[0].#subform[0].SectionI-DXSF[0].UnderNameNotes[0].Public2507Questions[0].PublicEvidenceReview[0].RadioButtonList[0]",
      "ref":0,
      "dbqName_yes":"2",
      "dbqName_no":"1",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please identify the evidence reviewed and the date range",
      "textdbqName":"form1[0].#subform[0].SectionI-DXSF[0].UnderNameNotes[0].Public2507Questions[0].PublicEvidenceReview[0].IdentifyEvidence[0]",
      "textanswer":""
   },

   {
      "question":"Do any of the ##name##'s heart conditions qualify within the generally accepted medical definition of Ischemic Heart Disease (IHD)?",
      "sub":"Please list the conditions that qualify",
      "type":"yesno",
      "show": true,
      "section": {
         page: "2",
         title: "MEDICAL HISTORY",
         number: "2B"
      },
      "presidence":"Yes",
      "maxLength":335,
      "radioGroup":"form1[0].#subform[0].IHD-2B[0].YN-RBfor2B[0]",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please identify the evidence reviewed and the date range",
      "textdbqName":"form1[0].#subform[0].Ifyeslistconditions[0]",
      "textanswer":""
   },
   {
      "question":"Provide the etiology, if known, of each of the Veteran's heart conditions, including the relationship/causality to other heart conditions, particularly the relationship/causality to the Veteran's IHD conditions",
      "sub":"",
      "type":"text",
      "optional": true,
      "show": true,
      "section": {
         page: "2",
         title: "MEDICAL HISTORY",
         number: "2C"
      },
      "questions":[
         {
            "main":"Heart condition #1",
            "subMain":"Etiology",
            "type":"text",
            "maxLength":30,
            "dbqName":"form1[0].#subform[0].EtiologytoIHD[0].Heart1[0]",
            "answer":"",
         },
         {
            "main":"Heart condition #2",
            "subMain":"Etiology",
            "type":"text",
            "maxLength":30,
            "dbqName":"form1[0].#subform[0].EtiologytoIHD[0].Heart2[0]",
            "answer":"",
         },
         {
            "main":"Additional heart conditions, list and provide etiology,",
            "subMain":"Etiology",
            "type":"text",
            "maxLength":230,
            "dbqName":"form1[0].#subform[0].IfadditionalHeartCond\\.[0]",
            "answer":"",
         },
      ]
   },
   {
      "question":"Is continuous medication required for control of the ##name##'s heart condition?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "2",
         title: "MEDICAL HISTORY",
         number: "2D"
      },
      "presidence":"Yes",
      "maxLength":230,
      "radioGroup":"form1[0].#subform[0].Cont\\.MedsSF[0].YN-RBfor2D[0]",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please list the medications required for the heart condition",
      "textdbqName":"form1[0].#subform[0].IfYesListMeds[0]",
      "textanswer":""
   },

   {
      "question":"Does ##name## have had an Myocardial Infraction (MI)?",
      "sub":"",
      "type":"radioModal",
      "multi": false,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "3",
         title: "MYOCARDIAL INFARCTION",
         number: "3A"
      },
      "radioGroup":"form1[0].#subform[0].SectionIII-MI[0].YNtoMIRB[0]",
      "questions":[
         {
            "main":"Had Myocardial Infraction (MI)",
            "dbqName":"1",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "text1": "",
            "dbqName1": "form1[0].#subform[0].SectionIII-MI[0].TextField6[1]",
            "placeholder1":"Indicate treatment facility for MI #1",
            "date1": "",
            "placeholderDate1":"Date for MI # 1",
            "dbqDate1": "form1[0].#subform[0].SectionIII-MI[0].TextField6[1]",
            "append1": true,

            "text2": "",
            "dbqName2": "form1[0].#subform[0].SectionIII-MI[0].TextField6[0]",
            "placeholder2":"Indicate treatment facility for MI #2",
            "date2": "",
            "dbqDate2": "form1[0].#subform[0].SectionIII-MI[0].TextField6[0]",
            "placeholderDate2":"Date for MI # 2",
            "append2": true,   // have to work on this

            "subItemOther": true,
            "textOther": "",
            "dbqNameOther": "form1[0].#subform[0].AdditionalMIs[0]",
            "placeholderOther":"If any additional MIs, list using above format",
         }, 
         {
            "main":"No Myocardial Infraction (MI)",
            "dbqName":"2",
            "answer":"",
         },                             
      ],
      "answer":""
   },




   {
      "question":"Has ##name## had any non-surgical or surgical procedures for the treatment of a heart condition?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "4",
         title: "PROCEDURES",
         number: "8A"
      },
      "presidence":"Yes",
      "radioGroup":"form1[0].#subform[0].SectionVIII-Procedures[0].YNto8A[0]",
      "ref":1,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Indicate the non-surgical or surgical procedures the Veteran has had for the treatment of a heart condition",
      "sub":"",
      "type":"radioModal",
      "multi": true,
      "show": false,
      "refId":1,
      "small": true,
      "cols": 2,
      "section": {
         page: "4",
         title: "PROCEDURES",
         number: "8A"
      },
      "questions":[
         {
            "main":"Percutaneous coronary intervention (PCI) (angioplasty)",
            "dbqName":"form1[0].#subform[0].SectionVIII-Procedures[0].CheckBox37[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            
            "text1": "",                  // First Text Field
            "dbqName1": "form1[0].#subform[0].SectionVIII-Procedures[0].TextField9[0]",
            "placeholder1":"Indicate treatment facility",
            
            "text2": "",                  // Second Text Field
            "dbqName2": "form1[0].#subform[0].SectionVIII-Procedures[0].TextField9[1]",
            "placeholder2":"Indicate treatment facility",
            
            "date1": "",                  // First Calendar
            "dbqDate1": "form1[0].#subform[0].SectionVIII-Procedures[0].TextField9[2]",
            "placeholderDate1":"Date of treatment",

            "date2": "",                  // Second Calendar
            "dbqDate2": "form1[0].#subform[0].SectionVIII-Procedures[0].TextField9[3]",
            "placeholderDate2":"Date of admission",
         },
         {
            "main":"Coronary artery bypass surgery",
            "dbqName":"form1[0].#subform[0].SectionVIII-Procedures[0].CheckBox37[1]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            
            "text1": "",                  // First Text Field
            "dbqName1": "form1[0].#subform[0].SectionVIII-Procedures[0].TextField9[4]",
            "placeholder1":"Indicate treatment facility",
            
            "text2": "",                  // Second Text Field
            "dbqName2": "form1[0].#subform[0].SectionVIII-Procedures[0].TextField9[17]",
            "placeholder2":"Indicate treatment facility",
            
            "date1": "",                  // First Calendar
            "dbqDate1": "form1[0].#subform[0].SectionVIII-Procedures[0].DateField18[0]",
            "placeholderDate1":"Date of treatment",

            "date2": "",                  // Second Calendar
            "dbqDate2": "form1[0].#subform[0].SectionVIII-Procedures[0].DateField19[0]",
            "placeholderDate2":"Date of admission",
         },
         {
            "main":"Cardiac/Heart transplants",
            "dbqName":"form1[0].#subform[0].SectionVIII-Procedures[0].CheckBox37[2]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            
            "text1": "",                  // First Text Field
            "dbqName1": "form1[0].#subform[0].SectionVIII-Procedures[0].TextField9[5]",
            "placeholder1":"Indicate treatment facility",
            
            "text2": "",                  // Second Text Field
            "dbqName2": "form1[0].#subform[0].SectionVIII-Procedures[0].TextField9[6]",
            "placeholder2":"Indicate treatment facility",
            
            "date1": "",                  // First Calendar
            "dbqDate1": "form1[0].#subform[0].SectionVIII-Procedures[0].DateField15[0]",
            "placeholderDate1":"Date of treatment",

            "date2": "",                  // Second Calendar
            "dbqDate2": "form1[0].#subform[0].SectionVIII-Procedures[0].DateField16[0]",
            "placeholderDate2":"Date of admission",

            "date3": "",                  // Third Calendar
            "dbqDate3": "form1[0].#subform[0].SectionVIII-Procedures[0].DateField17[0]",
            "placeholderDate3":"Date of discharge",
         },
         {
            "main":"Implanted cardiac pacemaker",
            "dbqName":"form1[0].#subform[0].SectionVIII-Procedures[0].CheckBox37[3]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            
            "text1": "",                  // First Text Field
            "dbqName1": "form1[0].#subform[0].SectionVIII-Procedures[0].TextField9[7]",
            "placeholder1":"Indicate treatment facility",
            
            "text2": "",                  // Second Text Field
            "dbqName2": "form1[0].#subform[0].SectionVIII-Procedures[0].TextField9[8]",
            "placeholder2":"Indicate treatment facility",
            
            "date1": "",                  // First Calendar
            "dbqDate1": "form1[0].#subform[0].SectionVIII-Procedures[0].DateField12[0]",
            "placeholderDate1":"Date of treatment",

            "date2": "",                  // Second Calendar
            "dbqDate2": "form1[0].#subform[0].SectionVIII-Procedures[0].DateField13[0]",
            "placeholderDate2":"Date of admission",

            "date3": "",                  // Third Calendar
            "dbqDate3": "form1[0].#subform[0].SectionVIII-Procedures[0].DateField14[0]",
            "placeholderDate3":"Date of discharge",
         },
         {
            "main":"Automatic implantable cardioverter defibrillator (AICD)",
            "dbqName":"form1[0].#subform[0].SectionVIII-Procedures[0].CheckBox37[4]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            
            "text1": "",                  // First Text Field
            "dbqName1": "form1[0].#subform[0].SectionVIII-Procedures[0].TextField9[9]",
            "placeholder1":"Indicate treatment facility",
            
            "text2": "",                  // Second Text Field
            "dbqName2": "form1[0].#subform[0].SectionVIII-Procedures[0].TextField9[10]",
            "placeholder2":"Indicate treatment facility",
            
            "date1": "",                  // First Calendar
            "dbqDate1": "form1[0].#subform[0].SectionVIII-Procedures[0].DateField10[0]",
            "placeholderDate1":"Date of treatment",

            "date2": "",                  // Second Calendar
            "dbqDate2": "form1[0].#subform[0].SectionVIII-Procedures[0].DateField11[0]",
            "placeholderDate2":"Date of admission",
         },
         {
            "main":"Heart valve replacement (prosthesis)",
            "dbqName":"form1[0].#subform[0].SectionVIII-Procedures[0].CheckBox37[5]",
            "answer":"",
            "multi": false,
            "showSubItems": false,

            "text1": "",                  // First Text Field
            "dbqName1": "form1[0].#subform[0].SectionVIII-Procedures[0].TextField9[12]",
            "placeholder1":"Indicate treatment facility",
            
            "text2": "",                  // Second Text Field
            "dbqName2": "form1[0].#subform[0].SectionVIII-Procedures[0].TextField9[11]",
            "placeholder2":"Indicate treatment facility",
            
            "date1": "",                  // First Calendar
            "dbqDate1": "form1[0].#subform[0].SectionVIII-Procedures[0].DateField7[0]",
            "placeholderDate1":"Date of treatment",

            "date2": "",                  // Second Calendar
            "dbqDate2": "form1[0].#subform[0].SectionVIII-Procedures[0].DateField8[0]",
            "placeholderDate2":"Date of admission",

            "date3": "",                  // Third Calendar
            "dbqDate3": "form1[0].#subform[0].SectionVIII-Procedures[0].DateField9[0]",
            "placeholderDate3":"Date of discharge",

            "subItems": [
               {
                  "main":"Mitral",
                  "dbqName":"form1[0].#subform[0].SectionVIII-Procedures[0].CheckBox37[9]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"Tricuspid",
                  "dbqName":"form1[0].#subform[0].SectionVIII-Procedures[0].CheckBox37[8]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"Aortic",
                  "dbqName":"form1[0].#subform[0].SectionVIII-Procedures[0].CheckBox37[7]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"Pulmonary",
                  "dbqName":"form1[0].#subform[0].SectionVIII-Procedures[0].CheckBox37[6]",
                  "colWidth": 3,
                  "answer":""
               }               
            ],
            "subAnswer":"",
            "subItemsLabel" :"Residuals",
         },
         {
            "main":"Ventricular aneurysmectomy",
            "dbqName":"form1[0].#subform[0].SectionVIII-Procedures[0].CheckBox37[10]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            
            "text1": "",                  // First Text Field
            "dbqName1": "form1[0].#subform[0].SectionVIII-Procedures[0].TextField9[13]",
            "placeholder1":"Indicate treatment facility",
            
            "text2": "",                  // Second Text Field
            "dbqName2": "form1[0].#subform[0].SectionVIII-Procedures[0].TextField9[14]",
            "placeholder2":"Indicate treatment facility",
            
            "date1": "",                  // First Calendar
            "dbqDate1": "form1[0].#subform[0].SectionVIII-Procedures[0].DateField4[0]",
            "placeholderDate1":"Date of treatment",

            "date2": "",                  // Second Calendar
            "dbqDate2": "form1[0].#subform[0].SectionVIII-Procedures[0].DateField5[0]",
            "placeholderDate2":"Date of admission",

            "date3": "",                  // Third Calendar
            "dbqDate3": "form1[0].#subform[0].SectionVIII-Procedures[0].DateField6[0]",
            "placeholderDate3":"Date of discharge",
         },
         {
            "main":"Other surgical and/or non surgical procedures for the treatment of a heart condition",
            "dbqName":"form1[0].#subform[0].SectionVIII-Procedures[0].#area[0].CheckBox37[11]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            
            "text1": "",                  // First Text Field
            "dbqName1": "form1[0].#subform[0].SectionVIII-Procedures[0].TextField9[15]",
            "placeholder1":"Indicate treatment facility",
            
            "text2": "",                  // Second Text Field
            "dbqName2": "form1[0].#subform[0].SectionVIII-Procedures[0].TextField9[16]",
            "placeholder2":"Indicate treatment facility",
            
            "date1": "",                  // First Calendar
            "dbqDate1": "form1[0].#subform[0].SectionVIII-Procedures[0].DateField1[0]",
            "placeholderDate1":"Date of treatment",

            "date2": "",                  // Second Calendar
            "dbqDate2": "form1[0].#subform[0].SectionVIII-Procedures[0].DateField2[0]",
            "placeholderDate2":"Date of admission",

            "date3": "",                  // Third Calendar
            "dbqDate3": "form1[0].#subform[0].SectionVIII-Procedures[0].DateField3[0]",
            "placeholderDate3":"Date of discharge",

            "subItemOther": true,
            "textOther": "",
            "dbqNameOther": "form1[0].#subform[0].SectionVIII-Procedures[0].#area[0].TextField6[0]",
            "placeholderOther":"Other surgical and/or non surgical procedures",
         },                                 
      ],
      "answer":""
   },

   {
      "question":"Does ##name## had any other hospitalizations for the treatment of a heart condition (other than for non-surgical and/or surgical procedures described earlier)?",
      "sub":"",
      "type":"radioModal",
      "multi": false,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "5",
         title: "HOSPITALIZATIONS",
         number: "9A"
      },
      "radioGroup":"form1[0].#subform[0].SectionIX-Hospitalizations[0].YNto9A[0]",
      "questions":[
         {
            "main":"Had hospitalizations for the treatment",
            "dbqName":"1",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "text1": "",
            "dbqName1": "form1[0].#subform[0].SectionIX-Hospitalizations[0].Facility9A[0]",
            "placeholder1":"Indicate treatment facility",
            "date1": "",
            "dbqDate1": "form1[0].#subform[0].SectionIX-Hospitalizations[0].DateofAdmission-9A[0]",
            "date2": "",
            "dbqDate2": "form1[0].#subform[0].SectionIX-Hospitalizations[0].DateofDischarge-9A[0]",

            "text2": "",
            "dbqName2": "form1[0].#subform[0].SectionIX-Hospitalizations[0].Condition9A[0]",
            "placeholder2":"Condition that resulted in the need for hospitalization",
         }, 
         {
            "main":"No hospitalizations for the treatment",
            "dbqName":"2",
            "answer":"",
         },                             
      ],
      "answer":""
   },

   {
      "question":"Please provide ##name##'s Heart Rate and Blood Pressure",
      "sub":"",
      "type":"text",
      "show": true,
      "section": {
         page: "5",
         title: "PHYSICAL EXAMINATION",
         number: "10A"
      },
      "questions":[
         {
            "main":"Heart Rate",
            "subMain":"Heart Rate",
            "type":"text",
            "maxLength":9,
            "dbqName":"form1[0].#subform[0].SectionX-PhysExam[0].TextField9[0]",
            "answer":"",
         },
         {
            "main":"Blood Pressure",
            "subMain":"Blood Pressure",
            "type":"text",
            "maxLength":7,
            "dbqName":"form1[0].#subform[0].SectionX-PhysExam[0].TextField9[1]",
            "answer":"",
         }
      ]
   },
   {
      "question":"Heart Rythm",
      "sub":"",
      "type":"radio",
      "show": true,
      "section": {
         page: "5",
         title: "PHYSICAL EXAMINATION",
         number: "10A"
      },
      "questions":[
         {
            "label":"Heart Rythm",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "Regular",
            "options":[
               {
                  "main":"Regular",
                  "dbqName":"form1[0].#subform[0].SectionX-PhysExam[0].CheckBox37[0]",
                  "sub":""
               },
               {
                  "main":"Irregular",
                  "dbqName":"form1[0].#subform[0].SectionX-PhysExam[0].CheckBox37[1]",
                  "sub":""
               }
            ],
            "answer":"Regular"
         }
      ]
   },
   {
      "question":"Point of maximal impact",
      "sub":"Choose only one",
      "type":"radioTiles",
      "multi": false,
      "show": true,
      "textarea": false,
      "small": true, //incase without textarea show tile
      "cols": 2,
      "section": {
         page: "5",
         title: "PHYSICAL EXAMINATION",
         number: "10A"
      },
      "questions":[
         {
            "main":"Not palpable",
            "dbqName":"form1[0].#subform[0].SectionX-PhysExam[0].CheckBox37[2]",
            "answer":"",
         },
         {
            "main":"4th intercostal space",
            "dbqName":"form1[0].#subform[0].SectionX-PhysExam[0].CheckBox37[3]",
            "answer":"",
         },
         {
            "main":"5th intercostal space",
            "dbqName":"form1[0].#subform[0].SectionX-PhysExam[0].CheckBox37[4]",
            "answer":"",
         },
         {
            "main":"Other (Specify)",
            "dbqName":"form1[0].#subform[0].SectionX-PhysExam[0].#area[0].CheckBox37[6]",
            "answer":"",
            "textarea": true,
            "maxLength":11,
            "textdbqName" : "form1[0].#subform[0].SectionX-PhysExam[0].#area[0].TextField6[0]",
            "placeholder": "Please describe",
            "textAnswer": ""
         }
      ],
      "answer":"",
      "textAnswer": ""
   },
   {
      "question":"Heart sounds",
      "sub":"Choose only one",
      "type":"radioTiles",
      "multi": false,
      "show": true,
      "textarea": false,
      "small": true,
      "cols": 2,
      "section": {
         page: "5",
         title: "PHYSICAL EXAMINATION",
         number: "10A"
      },
      "questions":[
         {
            "main":"Normal",
            "dbqName":"form1[0].#subform[0].SectionX-PhysExam[0].CheckBox37[5]",
            "answer":"",
         },
         {
            "main":"Abnormal (Specify)",
            "dbqName":"form1[0].#subform[0].SectionX-PhysExam[0].#area[1].CheckBox37[7]",
            "answer":"",
            "textarea": true,
            "maxLength":25,
            "textdbqName" : "form1[0].#subform[0].SectionX-PhysExam[0].#area[1].TextField6[1]",
            "placeholder": "Please describe",
            "textAnswer": ""
         }
      ],
      "answer":"",
      "textAnswer": ""
   },
   {
      "question":"Jugular-venous distension",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "5",
         title: "PHYSICAL EXAMINATION",
         number: "10A"
      },
      "ref":0,
      "dbqName_yes":"form1[0].#subform[0].SectionX-PhysExam[0].CheckBox37[8]",
      "dbqName_no":"form1[0].#subform[0].SectionX-PhysExam[0].CheckBox37[9]",
      "answer":"",
   },
   {
      "question":"Auscultation of the lungs",
      "sub":"Choose only one",
      "type":"radioTiles",
      "multi": false,
      "show": true,
      "textarea": false,
      "small": true, //incase without textarea show tile
      "cols": 2,
      "section": {
         page: "5",
         title: "PHYSICAL EXAMINATION",
         number: "10A"
      },
      "questions":[
         {
            "main":"Clear",
            "dbqName":"form1[0].#subform[0].SectionX-PhysExam[0].CheckBox37[11]",
            "answer":"",
         },
         {
            "main":"Bibasilar rales",
            "dbqName":"form1[0].#subform[0].SectionX-PhysExam[0].CheckBox37[10]",
            "answer":"",
         },
         {
            "main":"Abnormal (Describe)",
            "dbqName":"form1[0].#subform[0].SectionX-PhysExam[0].#area[2].CheckBox37[30]",
            "answer":"",
            "textarea": true,
            "maxLength":12,
            "textdbqName" : "form1[0].#subform[0].SectionX-PhysExam[0].#area[2].TextField6[2]",
            "placeholder": "Please describe",
            "textAnswer": ""
         }
      ],
      "answer":"",
      "textAnswer": ""
   },

   {
      "question":"Peripheral pulses",
      "sub":"",
      "type":"radio",
      "show": true,
      "section": {
         page: "5",
         title: "PHYSICAL EXAMINATION",
         number: "10A"
      },
      "questions":[
         {
            "label":"Dorsalis pedis",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "Normal",
            "options":[
               {
                  "main":"Normal",
                  "dbqName":"form1[0].#subform[0].SectionX-PhysExam[0].CheckBox37[14]",
                  "sub":""
               },
               {
                  "main":"Diminished",
                  "dbqName":"form1[0].#subform[0].SectionX-PhysExam[0].CheckBox37[13]",
                  "sub":""
               },
               {
                  "main":"Absent",
                  "dbqName":"form1[0].#subform[0].SectionX-PhysExam[0].CheckBox37[12]",
                  "sub":""
               }
            ],
            "answer":"Normal"
         },
         {
            "label":"Posterior tibial",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "Normal",
            "options":[
               {
                  "main":"Normal",
                  "dbqName":"form1[0].#subform[0].SectionX-PhysExam[0].CheckBox37[29]",
                  "sub":""
               },
               {
                  "main":"Diminished",
                  "dbqName":"form1[0].#subform[0].SectionX-PhysExam[0].CheckBox37[28]",
                  "sub":""
               },
               {
                  "main":"Absent",
                  "dbqName":"form1[0].#subform[0].SectionX-PhysExam[0].CheckBox37[27]",
                  "sub":""
               }
            ],
            "answer":"Normal"
         }
      ]
   },
   {
      "question":"Peripheral edema",
      "sub":"",
      "type":"radio",
      "show": true,
      "section": {
         page: "5",
         title: "PHYSICAL EXAMINATION",
         number: "10A"
      },
      "questions":[
         {
            "label":"Right lower extremity",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "Normal",
            "options":[
               {
                  "main":"Normal",
                  "dbqName":"form1[0].#subform[0].SectionX-PhysExam[0].CheckBox37[22]",
                  "sub":""
               },
               {
                  "main":"Trace",
                  "dbqName":"form1[0].#subform[0].SectionX-PhysExam[0].CheckBox37[21]",
                  "sub":""
               },
               {
                  "main":"1+",
                  "dbqName":"form1[0].#subform[0].SectionX-PhysExam[0].CheckBox37[23]",
                  "sub":""
               },
               {
                  "main":"2+",
                  "dbqName":"form1[0].#subform[0].SectionX-PhysExam[0].CheckBox37[24]",
                  "sub":""
               },
               {
                  "main":"3+",
                  "dbqName":"form1[0].#subform[0].SectionX-PhysExam[0].CheckBox37[25]",
                  "sub":""
               },
               {
                  "main":"4+",
                  "dbqName":"form1[0].#subform[0].SectionX-PhysExam[0].CheckBox37[26]",
                  "sub":""
               }
            ],
            "answer":"Normal"
         },
         {
            "label":"Left lower extremity",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "Normal",
            "options":[
               {
                  "main":"Normal",
                  "dbqName":"form1[0].#subform[0].SectionX-PhysExam[0].CheckBox37[16]",
                  "sub":""
               },
               {
                  "main":"Trace",
                  "dbqName":"form1[0].#subform[0].SectionX-PhysExam[0].CheckBox37[15]",
                  "sub":""
               },
               {
                  "main":"1+",
                  "dbqName":"form1[0].#subform[0].SectionX-PhysExam[0].CheckBox37[17]",
                  "sub":""
               },
               {
                  "main":"2+",
                  "dbqName":"form1[0].#subform[0].SectionX-PhysExam[0].CheckBox37[20]",
                  "sub":""
               },
               {
                  "main":"3+",
                  "dbqName":"form1[0].#subform[0].SectionX-PhysExam[0].CheckBox37[19]",
                  "sub":""
               },
               {
                  "main":"4+",
                  "dbqName":"form1[0].#subform[0].SectionX-PhysExam[0].CheckBox37[18]",
                  "sub":""
               }
            ],
            "answer":"Normal"
         }
      ]
   },
     
   {
      "question":"METs Testing",
      "sub":"The METs level checked below reflects the lowest activity level at which the Veteran begins experiencing any of the following symptoms: Check all that apply",
      "type":"radioTiles",
      "multi": true,
      "show": true,
      "textarea": false,
      "small": true, //incase without textarea show tile
      "cols": 2,
      "section": {
         page: "7",
         title: "METABOLIC EQUIVALENTS (METs) TESTING",
         number: "13D"
      },
      "questions":[
         {
            "main":"Breathlessness",
            "dbqName":"form1[0].#subform[0].SectionXIII-METs[0].Breathlessness[0]",
            "answer":"",
         },
         {
            "main":"Fatigue",
            "dbqName":"form1[0].#subform[0].SectionXIII-METs[0].Fatigue[0]",
            "answer":"",
         },
         {
            "main":"Angina",
            "dbqName":"form1[0].#subform[0].SectionXIII-METs[0].Angina[0]",
            "answer":"",
         },
         {
            "main":"Dizziness",
            "dbqName":"form1[0].#subform[0].SectionXIII-METs[0].CheckBox37[1]",
            "answer":"",
         },
         {
            "main":"Syncope",
            "dbqName":"form1[0].#subform[0].SectionXIII-METs[0].CheckBox37[0]",
            "answer":"",
         },
         {
            "main":"Other (Describe)",
            "dbqName":"form1[0].#subform[0].SectionXIII-METs[0].#area[4].CheckBox37[4]",
            "answer":"",
            "textarea": true,
            "maxLength":20,
            "textdbqName" : "form1[0].#subform[0].SectionXIII-METs[0].#area[4].TextField6[0]",
            "placeholder": "Please describe the frequency",
            "textAnswer": ""
         }
      ],
      "answer":"",
      "textAnswer": ""
   },

   {
      // this is the question with small tiles and textarea
      "question":"Results of Interview-based METs Test",
      "sub":"Choose only one",
      "type":"radioTiles",
      "multi": false,
      "show": true,
      "cols": 2,
      "section": {
         page: "7",
         title: "METs TESTING",
         number: "13D"
      },
      "questions":[
         // This Question's "main" looks same but actually all four main are diffenet strings, because selected option main will be in answer that will compare and update at backend
         {
            "main":"This METs level has been found to be consistent with activities such as",
            "redMain":" eating, dressing, taking a shower, slow walking (2 mph) for 1-2 blocks",
            "heading":"1-3 METs",
            "dbqName":"form1[0].#subform[0].SectionXIII-METs[0].#area[0].METs1-3[0]",
            "answer":"",
         },
         {
            "main":"This METs level has been found to be consistent with activities such as ",
            "redMain":"light yard work (weeding), mowing lawn (power mower), brisk walking (4 mph)",
            "heading":">3-5 METs",
            "dbqName":"form1[0].#subform[0].SectionXIII-METs[0].#area[1].Mets3-5[0]",
            "answer":"",
         },
         {
            "main":" This METs level has been found to be consistent with activities such as",
            "redMain":" walking 1 flight of stairs, golfing (without cart), mowing lawn (push mower), heavy yard work (digging)",
            "heading":">5-7 METs",
            "dbqName":"form1[0].#subform[0].SectionXIII-METs[0].#area[2].METs5-7[0]",
            "answer":"",
         },
         {
            "main":" This METs level has been found to be consistent with activities such as ",
            "redMain":"climbing stairs quickly, moderate bicycling, sawing wood, jogging (6 mph)",
            "heading":">7-10 METs",
            "dbqName":"form1[0].#subform[0].SectionXIII-METs[0].#area[3].METs7-10[0]",
            "answer":"",
         }
      ],
      "answer":"",
   },

   {
      "question":"Additional Comments",
      "sub":"",
      "optional": true,
      "type":"textarea",
      "maxLength":1015,
      "show": true,
      "section": {
         page: "8",
         title: "REMARKS",
         number: "15A"
      },
      "dbqName":"form1[0].#subform[0].SectionXV-Remarks[0].TextField6[0]",
      "answer":""
   }
 ]

 export default heart_questions ;
